import Logo from './Logo';
import styled from 'styled-components';
import Onboarding from './Onboarding';
import { up } from 'styled-breakpoints';
import {ThemeProvider} from 'styled-components';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { ReactQueryConfigProvider } from 'react-query';
import { configureSentry } from '../utils/sentryUtils';
import ENV from '../constants/envConstants';
import { ReactQueryDevtools } from 'react-query-devtools'
import { Helmet } from "react-helmet";
import breakpoints from "../constants/breakpoints";

if (!ENV.IS_DEVELOPMENT) {
  configureSentry();
}

const Main = styled.div`
  max-width: 90%;
  margin: 0 auto;
  display: block;
  margin-top: 1em;
  box-sizing: border-box;

  ${up('sm')} {
    max-width: 85%;
    margin-top: 1.5em;
  }

  ${up('md')} {
    max-width: 80%;
  }

  ${up('lg')} {
    margin-top: 1.75em;
    max-width: 70%;
  }

  ${up('xl')} {
    max-width: 60%;
    margin-top: 2em;
  }

  ${up('xxl')} {
    max-width: 55%;
    margin-top: 3em;
  }

  ${up('giant')} {
    max-width: 50%;
    margin-top: 3.5em;
  }

`;

const queryConfig = {
  queries: {
    useErrorBounaries: true,
    staleTime: 10000,
  },
};


function App() {
  return (
    <ThemeProvider theme={breakpoints}>
      {ENV.IS_DEVELOPMENT && <ReactQueryDevtools initialIsOpen={false} />}
      <Router>
        <ReactQueryConfigProvider config={queryConfig}>
          <Helmet>
            <title>Eatsee - Signup</title>
          </Helmet>
          <Main>
            <Logo />
            <Onboarding />
          </Main>
        </ReactQueryConfigProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
